import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import HeaderRedirect from '../../core/HeaderRedirect';
import { useAuth } from '../../CustomHooks';
import { LoginState } from '../../UserManagement';
import { isLikelyNetworkTimeoutError } from '../../UserManagementHelpers';
import { useErrorStatus } from '../EnableErrorMessagePopup/EnableErrorMessagePopup';
import UnauthenticatedHeader from '../UnauthenticatedHeader/UnauthenticatedHeader';

export const SmartHeader = (props) => {
  // console.debug(`%cSmartHeader render`, 'background: pink; color: black');
  const auth = useAuth();
  const onShowErrorMessage = useErrorStatus();
  const history = useHistory();
  const location = useLocation();
  const user = useSelector((state) => state.user);

  useEffect(() => {
    // console.debug(
    //   `%cCHECK if login state is unknown`,
    //   'background: pink; color: black'
    // );
    if (auth.isUserLoggedInStateUnknown()) {
      void auth.reactivateUserSession().catch((error: unknown) => {
        if (isLikelyNetworkTimeoutError(error) && typeof onShowErrorMessage === 'function') {
          onShowErrorMessage(
            'We are having trouble reaching Peekapak right now. Please check your connection and try again.',
            'Connection timed out',
          );
          return;
        }

        console.error('Cannot reactivate user session from SmartHeader:', error);
      });
    }
  }, [auth, onShowErrorMessage]);

  // console.debug(
  //   `%cCURRENT state ===`,
  //   'background: pink; color: black',
  //   props.loginState
  // );
  if (user?.loginState === LoginState.loggedIn) {
    return <HeaderRedirect history={history} location={location} isHidePeekaville />;
  } else if (user?.loginState === LoginState.loggedOut || user?.loginState === LoginState.expiredSession) {
    return <UnauthenticatedHeader {...props} />;
  } else return null;
};
